import { generatePath } from 'react-router-dom';

type Params = { [key: string]: string | number | null | undefined };

export function buildPath(parts: string | string[], params?: Params): string {
  const partsArray = Array.isArray(parts) ? parts : [parts];

  const fullPath = partsArray.join('/').replace(/\/{2,}/g, '/');

  if (params) {
    const fullParams = Object.keys(params).reduce((result, key) => {
      result[key] = params[key] !== undefined && params[key] !== null ? params[key] : '';
      return result;
    }, {} as Params);

    return generatePath(fullPath, fullParams);
  } else {
    return fullPath;
  }
}
